import { useInterval } from "@mantine/hooks";
import { useEffect, useState } from "react";

export const useDelay = (delay: number) => {
  const [timer, setTimer] = useState(0);

  const interval = useInterval(() => {
    if (timer < delay) {
      setTimer((s) => s + 1);
    }
  }, 1000);

  useEffect(() => {
    interval.start();

    return interval.stop;
  }, [interval]);

  const isDelayElapsed = timer >= delay;

  return { isDelayElapsed, timer };
};
